

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControlFeedbackComponent, LoaderSpinnerComponent, PageHeaderComponent } from '@aston/foundation';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { NgxCurrencyDirective } from 'ngx-currency';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

import { FileUploadComponent } from '../shared-module/components/file-upload/file-upload.component';
import { FileUploadInstructionsComponent } from '../shared-module/components/file-upload-instructions/file-upload-instructions.component';
import { LayoutBaseComponent } from '../shared-module/layouts/layout-base/layout-base.component';
import { TopBarComponent } from '../shared-module/components/top-bar/top-bar.component';
import { SubsidiariesPageComponent } from '../subsidiaries-module/pages/subsidiaries-page/subsidiaries-page.component';
import { SubsidiaryDetailCompanyPageComponent } from '../subsidiaries-module/pages/subsidiary-detail-company-page/subsidiary-detail-company-page.component';
import { SubsidiaryDetailUsersPageComponent } from '../subsidiaries-module/pages/subsidiary-detail-users-page/subsidiary-detail-users-page.component';

import { NewAccountGuard, NewAccountStepGuard } from './guards';
import { NewAccountStepsComponent } from './components/new-account-steps/new-account-steps.component';
import { NewAccountValidationPageComponent } from './pages/new-account-validation-page/new-account-validation-page.component';
import { NewAccountCompanyPageComponent } from './pages/new-account-company-page/new-account-company-page.component';
import { NewAccountLayoutComponent } from './layouts/new-account-layout/new-account-layout.component';

@NgModule({
	imports: [
		CommonModule,
		FileUploadComponent,
		FileUploadInstructionsComponent,
		FormControlFeedbackComponent,
		FormsModule,
		LayoutBaseComponent,
		LoaderSpinnerComponent,
		NgbTooltipModule,
		NgSelectModule,
		NgxCurrencyDirective,
		NgxMaskDirective,
		NgxMaskPipe,
		PageHeaderComponent,
		ReactiveFormsModule,
		RouterModule,
		SubsidiariesPageComponent,
		SubsidiaryDetailCompanyPageComponent,
		SubsidiaryDetailUsersPageComponent,
		TopBarComponent,
		TranslateModule,
		NewAccountCompanyPageComponent,
		NewAccountLayoutComponent,
		NewAccountStepsComponent,
		NewAccountValidationPageComponent,
	],
	providers: [
		NewAccountGuard,
		NewAccountStepGuard,
		provideNgxMask()
	]
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class AccountModule { }

